import axios from "axios";
import Swal from 'sweetalert2';

const state = {
  contactList: [], 
  contactArr: [],
  contactArray: [],
  contactID: '',
  selectedContact: null,
  selectedAccount: null,
  isEditing: false
};
  
const mutations = {
  initializeStore(state){
    state.contactList = [];
    state.contactArr = [];
    state.contactArray = [];
    state.contactID = '';
    state.selectedContact = null;
    state.selectedAccount = null;
    state.isEditing = false;
  },
  SET_SELECTED_CONTACT(state, contact) {
    state.selectedContact = contact;
    state.isEditing = true;
  },
  SET_SELECTED_ACCOUNT(state, account) {
    state.selectedAccount = account;
  },
  LIST_CONTACTS(state, contacts) {
    state.contactList = contacts;
  },
  CONTACT_ARRAY(state, contactArray){
    state.contactArray = contactArray;
  },
  SET_STATE(state, payload) {
    for (const key in payload) {
        if (payload.hasOwnProperty(key) && key in state) {
            state[key] = payload[key];
        }
    }
  },
  SET_SEARCH_FILTERS(state, search_filter){
    for(const [key, value] of Object.entries(search_filter)){
    }
  },
  RESET_SEARCH_FILTERS(state){

  }
};
  
const actions = {
  updateState({ commit }, newState) {
    commit('SET_STATE', newState);
  },
  
  async createLeadContact({ commit,state }, formData) {
    return axios.post('api/v1/create-lead-contact/', formData)
    .then((response)=>{
      return response;
    })
    .catch((error)=>{
      console.log(error.message);
      throw error;
    })
  },

  fetchLeadContacts({ commit,state }, formData) {
    state.contactArr = [];
    axios.post(`api/v1/get-lead-contacts/`,formData)
    .then((response)=>{
      for(let i=0; i< response.data.length; i++){
        state.contactArr.push((response.data[i].full_name + " - Designation: " + response.data[i].designation));
      }
      commit('LIST_CONTACTS', response.data);
    })
    .catch((error)=>{
      console.log(error.message);
    })
    
  },
  fetchLeadContact({ commit,state }, formData) {
    axios.post(`api/v1/get-lead-contacts/`,formData)
    .then((response)=>{
        const selectedAcc = response.data.account.account_name + " - Email: " + response.data.account.email;
        state.selectedContact = response.data;
        commit('SET_SELECTED_ACCOUNT',selectedAcc);
        commit('SET_SELECTED_CONTACT',response.data);
    })
    .catch((error)=>{
      console.log(error.message);
    })
    
  },
  handleSelectedContact({ commit, state }, option){
    state.contactArray = [];
    const selectedContact = state.contactList.find(contact => (contact.full_name + " - Designation: " + contact.designation) === option);
    if (selectedContact) {
        state.contactID = selectedContact.crm_contact_id;
        state.contactArray = [...state.contactArray, selectedContact];
    }
    commit('CONTACT_ARRAY', state.contactArray);
      
  },

  async updateLeadContact({ commit,state }, formData) {
    return axios.put(`api/v1/update-lead-contact/`,formData)
    .then((response)=>{
      return response;
    })
    .catch((error)=>{
      console.log(error.message);
      throw error;
    })  
  },

  deleteLeadContact({ commit,state }, formData) {
    Swal.fire({
      title: "Are you sure?",
      text: `Do you wish to delete Contact?`,
      type: 'warning',
      showCloseButton: true,
      showCancelButton: true,
      confirmButtonText: 'Yes Delete Contact!',
      cancelButtonText: 'Cancel!',
      customClass: {
          confirmButton: 'swal2-confirm-custom',
          cancelButton: 'swal2-cancel-custom',
      },
      showLoaderOnConfirm: true,
    }).then((result) => {
      if (result.value) {
        axios.post(`api/v1/delete-lead-contact/`,formData)
        .then((response)=>{
          if(response.data.msg == "Success"){
              Swal.fire("Poof! Contact removed succesfully!", {
                icon: "success",
              }); 
          }else{
            Swal.fire({
              title: "Error Deleting Contact",
              icon: "warning",
            });
          }                   
        })
        .catch((error)=>{
          console.log(error.message);
          Swal.fire({
            title: error.message,
            icon: "warning",
          });
        })
      }else{
        Swal.fire(`Contact has not been deleted!`);
      }
    })
  },

};
  
const getters = {
  // users: (state) => state.users,
  // currentUser: (state) => state.currentUser,
};
  
export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
  
  